import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { WorkspaceInfoBasic } from '../../fragments/generated/WorkspaceInfoBasic';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWorkspacesBasicQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
}>;


export type GetWorkspacesBasicQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, workspaces: { __typename?: 'WorkspaceConnection', totalCount: number, nodes: Array<{ __typename?: 'Workspace', id: string, name: string, projectNotificationsEnabled?: boolean | null, isWorkfront?: boolean | null, visibleActiveProjectCount?: number | null, visibleInactiveProjectCount?: number | null, externallyManagedIntegration?: { __typename?: 'ExternallyManagedIntegration', integration?: Types.Integration | null, canUpdateInternalAssetContentSecurity: boolean, canUpdateWorkspaceName: boolean } | null, images?: { __typename?: 'Images', image128?: string | null, original?: string | null } | null, permissions?: { __typename?: 'WorkspacePermissions', canCreateProject: boolean, canEditUserPermissions: boolean, canManageResourceControlPolicies: boolean } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };


export const GetWorkspacesBasic = /*#__PURE__*/ gql`
    query GetWorkspacesBasic($accountId: ID!, $page: PageInput!) {
  account(accountId: $accountId) {
    id
    workspaces(page: $page, order: {direction: ASC, field: NAME}) {
      nodes {
        ...WorkspaceInfoBasic
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    ${WorkspaceInfoBasic}` as unknown as DocumentNode<GetWorkspacesBasicQuery, GetWorkspacesBasicQueryVariables>;

          

          export const useGetWorkspacesBasicQuery = (options?:QueryHookOptions<GetWorkspacesBasicQuery, GetWorkspacesBasicQueryVariables>) => useQuery(GetWorkspacesBasic, options);

          

          export type GetWorkspacesBasicQueryOptions = QueryHookOptions<GetWorkspacesBasicQuery, GetWorkspacesBasicQueryVariables>;

          

          export const useGetWorkspacesBasicLazyQuery = (options?:LazyQueryHookOptions<GetWorkspacesBasicQuery, GetWorkspacesBasicQueryVariables>) => useLazyQuery(GetWorkspacesBasic, options);

          

          export type GetWorkspacesBasicQueryResult = ReturnType<typeof useGetWorkspacesBasicQuery>;

          
